import React, { useState } from 'react';
import { useDocumentTitle } from '../_hooks/useDocumentTitle';
import { useResetModuleWrapperStyles } from '../_hooks/useResetModuleWrapperStyles';
import { PersonalInfo } from './stages/PersonalInfo/PersonalInfo';
import { CharitableGiving } from './stages/CharitableGiving/CharitableGiving';
import { useRouteParams } from './hooks/useRouteParams';

export const CharitableGivingWorkflow = () => {
  useResetModuleWrapperStyles();

  useDocumentTitle('Charitable Giving - Workflow');

  const { goalId } = useRouteParams();

  const [workflowStage, setWorkflowStage] = useState<'personal-info' | 'charitable-giving'>(
    goalId ? 'charitable-giving' : 'personal-info',
  );

  if (workflowStage === 'personal-info') {
    return <PersonalInfo onNextStage={() => setWorkflowStage('charitable-giving')} />;
  }

  return <CharitableGiving onPreviousStage={() => setWorkflowStage('personal-info')} />;
};
